import { render, staticRenderFns } from "./TBExpander.vue?vue&type=template&id=86e447c6&"
import script from "./TBExpander.vue?vue&type=script&lang=js&"
export * from "./TBExpander.vue?vue&type=script&lang=js&"
import style0 from "./TBExpander.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports